import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { InformesPlenariaComponent } from './components/informes-plenaria/informes-plenaria.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { LoginComponent } from './components/login/login.component';
import { NoticiasComponent } from './components/noticias/noticias.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { ParlacenTvComponent } from './components/parlacen-tv/parlacen-tv.component';
import { MemberComponent } from './components/member/member.component';
import { UsersComponent } from "./components/users/users.component";
import { DiputadosComponent } from "./components/diputados/diputados.component";

const appRoutes: Routes = [
    { path: '', redirectTo: 'iniciar-sesion', pathMatch: 'full' },
    { path: 'inicio', component: InicioComponent },
    { path: 'iniciar-sesion', component: LoginComponent },
    { path: 'noticias', component: NoticiasComponent },
    { path: 'agenda', component: AgendaComponent },
    { path: 'documentos-plenaria', component: InformesPlenariaComponent },
    { path: 'parlacen-tv', component: ParlacenTvComponent },
    { path: 'members', component: MemberComponent },
    { path: 'usuarios', component: UsersComponent },
    { path: 'diputados', component: DiputadosComponent },
    { path: '**', component: InicioComponent },

]
export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' });
